import styles from './Topbar.module.css'
import Logo from '../../../assets/wiki-logo-mobile.svg?react'
import Bell from '../../../assets/bell-primary.svg?react'
import Burger from '../../../assets/burger.svg?react'
import Donation from '../../../assets/donation.svg?react'
import LoginWhite from '../../../assets/login-white.svg?react'
import Account from '../../../assets/account.svg?react'
import { useTranslation } from 'react-i18next'
import WikiLoveMonuments from '../../Mobile/WikiLoveMonuments'
import { useMemo, useState } from 'react'
import classNames from 'classnames'
import { useDetectClickOutside } from 'react-detect-click-outside'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthUser } from 'use-eazy-auth'
// import Legend from '../Legend'
import Menu from '../Menu'
import ModalLanguage from '../ModalLanguage'
import ModalPaese from '../ModalPaese'
import { API_URL, IS_WIKI_DOMAIN } from '../../../const'
import { getActiveGeocontext, unicodeToChar } from '../../../utils'
import { SlidesPresentazioneDesktop } from '../Layout'
import Credits from '../../Mobile/Credits'
import License from '../../../assets/icon-license.svg?react'
import Close from '../../../assets/close.svg?react'

export default function Topbar({
  setScrapingOpen,
  scrapingOpen,
  setProfileOpen,
  profileOpen,
  setScrapingOsmOpen,
  scrapingOsmOpen,
  setScrapingCommonsOpen,
  scrapingCommonsOpen,
}: {
  setScrapingOpen: (value: boolean) => void
  scrapingOpen: boolean
  setProfileOpen: (value: boolean) => void
  profileOpen: boolean
  setScrapingOsmOpen: (value: boolean) => void
  scrapingOsmOpen: boolean
  setScrapingCommonsOpen: (value: boolean) => void
  scrapingCommonsOpen: boolean
}) {
  const { t, i18n } = useTranslation()
  const [infoWiki, setInfoWiki] = useState(false)
  const [presentazione, setPresentazione] = useState(false)
  const [show, setShow] = useState(false)
  const [showCredits, setShowCredits] = useState(false)

  const [modalLang, setModalLang] = useState(false)
  const [modalPaese, setModalPaese] = useState(false)
  const { user } = useAuthUser()
  const username = user ? user.username.replace('mw--', ' ') : ''

  const menuRed = useDetectClickOutside({ onTriggered: () => setShow(false) })
  const { pathname, search } = useLocation()

  const activeGeocontext = getActiveGeocontext()

  const activeContest = useMemo(() => {
    if (!activeGeocontext) return null
    if (!activeGeocontext.next_contest) return null
    if (activeGeocontext.next_contest.active)
      return activeGeocontext.next_contest
    return null
  }, [activeGeocontext])

  const navigate = useNavigate()

  const [showLicenseModal, setShowLicenseModal] = useState(false)

  return (
    <>
      <div
        className={`${styles.Topbar} ${!IS_WIKI_DOMAIN ? styles.TopbarDebug : ''}`}
      >
        <div
          className={styles.WikiLoveMonuments}
          onClick={() => {
            navigate('/')
          }}
        >
          <div
            className="me-1 pointer"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setModalPaese(true)
            }}
          >
            <span style={{ fontSize: 25 }}>
              {unicodeToChar(activeGeocontext?.flag)}
            </span>
          </div>
          <Logo /> {t('GENERIC_WLM')}
        </div>
        {activeContest && (
          <div>
            <div className={styles.ButtonConcorso}>
              <Bell />{' '}
              {i18n.language === 'it'
                ? activeContest?.label
                : activeContest?.label_en}
            </div>
          </div>
        )}
        <div className="d-flex align-items-center h-100">
          {activeGeocontext?.enable_donations_text &&
            activeGeocontext.donations_link && (
              <div
                className={`pointer ${styles.Login}`}
                onClick={() =>
                  window.open(activeGeocontext.donations_link, '_blank')
                }
              >
                <Donation className="me-2" /> {t('MENU_DONATIONS')}
              </div>
            )}
          <div>
            <div
              onClick={() => {
                if (username) {
                  setScrapingOpen(false)
                  setProfileOpen(!profileOpen)
                } else {
                  setShowLicenseModal(true)
                }
              }}
              className={styles.Login}
            >
              {username ? (
                <Account className="me-2" />
              ) : (
                <LoginWhite className="me-2" />
              )}{' '}
              {username ? username : t('GENERIC_LOGIN')}
            </div>
          </div>

          <div
            style={{
              width: '0.5px',
              height: '60%',
              backgroundColor: '#D0DFE4',
            }}
            className="me-2"
          ></div>
          <div>
            <div
              className={classNames(styles.Burger, {
                [styles.BurgerOpen]: show,
              })}
              ref={menuRed}
            >
              <Burger
                className="pointer"
                onClick={() => {
                  setShow(!show)
                }}
              />
            </div>
            {show && (
              <Menu
                setInfoWiki={setInfoWiki}
                setModalLang={setModalLang}
                setPresentazione={setPresentazione}
                setModalPaese={setModalPaese}
                setScrapingOpen={setScrapingOpen}
                setScrapingOsmOpen={setScrapingOsmOpen}
                scrapingOsmOpen={scrapingOsmOpen}
                setScrapingCommonsOpen={setScrapingCommonsOpen}
                scrapingOpen={scrapingOpen}
                setProfileOpen={setProfileOpen}
                scrapingCommonsOpen={scrapingCommonsOpen}
                setShowCredits={setShowCredits}
                setShowLicenseModal={setShowLicenseModal}
              />
            )}
          </div>
        </div>
      </div>
      <ModalLanguage modalLang={modalLang} setModalLang={setModalLang} />
      <ModalPaese modalPaese={modalPaese} setModalPaese={setModalPaese} />

      <WikiLoveMonuments
        infoWiki={infoWiki}
        setPresentazione={setPresentazione}
        setInfoWiki={(infoWiki: boolean) => setInfoWiki(infoWiki)}
        activeGeocontext={activeGeocontext}
      />
      <Credits openCredits={showCredits} setOpenCredits={setShowCredits} />
      {presentazione && (
        <SlidesPresentazioneDesktop
          isFromPageWiki
          setPresentazione={setPresentazione}
        />
      )}
      {showLicenseModal && (
        <div
          className={styles.ResponseOverlay}
          onClick={() => {
            setShowLicenseModal(false)
          }}
        >
          <div className={styles.ResponseContainer}>
            <div
              className="position-absolute pointer"
              style={{
                top: 20,
                right: 20,
              }}
            >
              <Close />
            </div>
            <div>
              <License />
            </div>
            <div className={styles.TextBeforeLogin}>
              {t('USR_BOX_CONDITION_TITLE')}
            </div>
            <div className={styles.License}>
              <input
                checked
                className="me-2"
                type="checkbox"
                onChange={() => {}}
              />
              {t('USR_BOX_CONDITION_TEXT')}
            </div>
            <div className="w-100">
              <button
                className={styles.ButtonAccetta}
                // disabled
                onClick={() => {
                  localStorage.setItem('redirectUrl', pathname + search)
                  window.location.href = `${API_URL}/oauth/oauth-login?redirect_uri=${window.location.href}`
                }}
              >
                {t('USR_BOX_CONDITION_ACCEPT_BUTTON')}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
